import {Form, Input, Spin} from "antd";
import Modal from "../components/Modal/Modal";
import React, {useEffect, useState} from "react";
import runAsync from "@/script/runAsync.mjs";
import useHTTP from "@/hooks/useHTTP.mjs";
import {useOpenModal} from "@/components/Modal/index.mjs";

export const useConfirmMainPackage = () => {
    const openModal = useOpenModal();

    return async ({ssId})=> {
        return await openModal(<ModalConfirmMainPackage ssId={ssId}/>)
    }
}


const ModalConfirmMainPackage = ({ssId, onOk, ...props}) => {
    const http = useHTTP();
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false);

    const doQuery = async () => {
        try {
            setLoading(true);
            const data = await runAsync(
                async () => {
                    return await http.get(`/archsss/${ssId}`)
                }, {
                    error: {content: (err) => `查询失败: ${err.message}`},
                    loading: {show: true},
                    success: {show: false},
                });
            if (data) {
                form.setFieldsValue(data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    const handleOk = async () => {
        try {
            setLoading(true)
            form.validateFields().then(async ({mainPackage}) => {
                onOk(mainPackage)
            })
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (ssId) {
            doQuery()
        }
    }, []);

    return (
        <Modal
            title="确认代码包名"
            width={600}
            {...props}
            onOk={handleOk}
        >
            <Spin spinning={loading}>
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="mainPackage"
                        label="代码包名"
                        rules={[{required: true, message: '请输入代码包名!'}]}
                    >
                        <Input allowClear/>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    )
}
